import React, { useState, useRef, useEffect } from "react";
import {
  AppBar,
  Avatar,
  Toolbar,
  IconButton,
  InputBase,
  Menu,
  MenuItem,
  Hidden,
  ListItem,
  List,
  Box,
  Typography,
  Grid,
  Divider,
  Button,
  InputAdornment,
  useMediaQuery,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { useTheme } from "@material-ui/styles";
import {
  Person as AccountIcon,
  Search as SearchIcon,
  Menu as MenuIcon,
} from "@material-ui/icons";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { useHistory } from "react-router-dom";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import qs from "query-string";

// styles
import useStyles from "./styles";

// context
import { useMatomo } from "@datapunt/matomo-tracker-react";
import {
  useUserState,
  useUserDispatch,
  signOut,
} from "../../context/UserContext";

import StyledButton from "../../components/core/StyledButton";

import { staticUrl, apiUrl } from "../../utils/const";
import axios from "../../axios";
import { useQuota } from "../../useGlobal";

export default function Header (props) {
  const classes = useStyles();

  // global
  const { isAuthenticated, userInfo, loginUrl, platform } = useUserState();
  const { quota, isPending } = useQuota({ refreshInterval: 5000 });
  const { device_limit = "", device_in_use = "" } = quota;
  const history = useHistory();
  const { pushInstruction } = useMatomo();

  const textFieldRef = useRef();
  const textFieldRefOfBar = useRef();

  const parsed = qs.parse(window.location.search);
  const searchQuery = parsed.q;

  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down("sm"), {
    defaultMatches: false,
  });
  const isXs = useMediaQuery(theme.breakpoints.down("xs"), {
    defaultMatches: false,
  });

  const videoExportLink = `${axios.defaults.baseURL}/api/v1/users/platform-video/${platform.name}/export`;
  const searchMaxLength = 30;
  const searchMinLength = 1;

  // global
  const userDispatch = useUserDispatch();

  // local
  const [profileMenu, setProfileMenu] = useState(null);
  const [minimalMenu, setMinimalMenu] = useState(null);
  const [isSearchHover, setSearchHover] = useState(false);
  const [searchBarShow, setSearchBarShow] = useState(false);
  const query =
    (textFieldRef.current && textFieldRef.current.value) ||
    (textFieldRefOfBar.current && textFieldRefOfBar.current.value);
  const hasQuery = !isEmpty(query);
  const userName = isSm
    ? ""
    : get(userInfo, "user_type") === 0
    ? get(userInfo, "real_name")
    : get(userInfo, "org_name");

  const placeholderText = "搜尋電影、演員或導演";
  const placeholder = !isXs && isSearchHover ? placeholderText : "";
  const { intro_url = "" } = platform;
  const contact_us_url = "/contact-us";

  const navlink = isAuthenticated
    ? [
        {
          id: 2,
          title: "常見問題",
          link: contact_us_url,
        },
        {
          id: 3,
          title: "下載片單",
          link: videoExportLink,
        },
      ]
    : [
        {
          id: 2,
          title: "常見問題",
          link: contact_us_url,
        },
      ];

  useEffect(() => {
    if (props.changeStyleOnScroll) {
      window.addEventListener("scroll", headerStyleChange);
    }
    return function cleanup () {
      if (props.changeStyleOnScroll) {
        window.removeEventListener("scroll", headerStyleChange);
      }
    };
  }, []);

  useEffect(() => {
    if (textFieldRef.current && !isEmpty(searchQuery)) {
      textFieldRef.current.value = searchQuery;
    }
    if (textFieldRefOfBar.current && !isEmpty(searchQuery)) {
      textFieldRefOfBar.current.value = searchQuery;
    }

    const listener = event => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        console.log("Enter key was pressed. Run your function.");
        onSubmit();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, []);

  const handleSearchHoverOpen = () => {
    if (!isXs) {
      setSearchHover(true);
    }
  };

  const handleSearchHoverClose = () => {
    if (!isXs) {
      setSearchHover(false);
    }
  };

  const headerStyleChange = () => {
    const { changeStyleOnScroll } = props;
    const windowsScrollTop = window.pageYOffset;
    if (windowsScrollTop > changeStyleOnScroll.height) {
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(classes["sticky"]);
      document
        .getElementById("sticky-phantom")
        .classList.add(classes["stickyPhantomShow"]);
    } else {
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes["sticky"]);
      document
        .getElementById("sticky-phantom")
        .classList.remove(classes["stickyPhantomShow"]);
    }
  };

  const onSubmit = () => {
    // open search bar if the screensize is xs and search bar is hidden
    if (isXs && !searchBarShow) {
      setSearchBarShow(true);
      return;
    }
    const query = textFieldRef.current.value || textFieldRefOfBar.current.value;
    if (!isEmpty(query) && query.length > 0) {
      history.push(`/video/search?q=${query.substr(0, 30)}`);
    }
  };

  return (
    <div>
      <div id='sticky-phantom' className={classes.stickyPhantom}></div>
      <AppBar position='relative' className={classes.appBar}>
        <Toolbar
          className={classNames(classes.toolbar, {
            [classes.searchToolBar]: searchBarShow,
            [classes.hide]: !isXs || !searchBarShow,
          })}
        >
          <div className={classes.navigationContainer}>
            <div
              className={classNames(
                {
                  [classes.searchOverride]: true,
                },
                classes.search,
              )}
            >
              <InputBase
                inputRef={textFieldRefOfBar}
                className={classNames(classes.searchInput, {
                  [classes.searchFocused]: true
                    ? true
                    : !isXs && (isSearchHover || hasQuery),
                })}
                classes={{
                  root: classes.inputRoot,
                  input: classes.inputInput,
                }}
                placeholder={true ? placeholderText : placeholder}
                inputProps={{
                  "aria-label": "search",
                  maxLength: searchMaxLength,
                  minLength: searchMinLength,
                }}
                endAdornment={
                  <InputAdornment
                    position='end'
                    classes={{
                      positionEnd: classes.positionEnd,
                    }}
                  >
                    <IconButton
                      type='submit'
                      className={classes.searchButton}
                      aria-label='search'
                      onClick={() => onSubmit()}
                    >
                      <SearchIcon className={classes.searchIcon} />
                    </IconButton>
                  </InputAdornment>
                }
                onMouseEnter={handleSearchHoverOpen}
                onMouseLeave={handleSearchHoverClose}
              />
            </div>
            <div>
              <StyledButton
                variant='text'
                onClick={() => {
                  setSearchBarShow(false);
                }}
              >
                取消
              </StyledButton>
            </div>
          </div>
        </Toolbar>
        <Toolbar className={classes.toolbar}>
          <div className={classes.logoContainer}>
            <Link to='/' title='首頁'>
              {isEmpty(platform) ? (
                <Skeleton
                  classes={{ root: classes.logoImage }}
                  variant='rect'
                  animation='wave'
                />
              ) : (
                <img
                  className={classes.logoImage}
                  src={`${staticUrl}/${platform.logo_url}`}
                  alt={`${platform.nickname}`}
                />
              )}
            </Link>
          </div>

          <div className={classes.grow} />

          <div className={classes.navigationContainer}>
            <div
              className={classNames(
                {
                  [classes.searchOverride]: false,
                },
                classes.search,
              )}
            >
              <InputBase
                inputRef={textFieldRef}
                className={classNames(classes.searchInput, {
                  [classes.searchFocused]: false
                    ? true
                    : !isXs && (isSearchHover || hasQuery),
                })}
                classes={{
                  root: classes.inputRoot,
                  input: isXs ? classes.hide : classes.inputInput,
                }}
                placeholder={false ? placeholderText : placeholder}
                inputProps={{
                  "aria-label": "search",
                  maxLength: searchMaxLength,
                  minLength: searchMinLength,
                }}
                endAdornment={
                  <InputAdornment
                    position='end'
                    classes={{
                      positionEnd: classes.positionEnd,
                    }}
                  >
                    <IconButton
                      type='submit'
                      className={classes.searchButton}
                      aria-label='search'
                      onClick={() => {
                        onSubmit();
                      }}
                    >
                      <SearchIcon className={classes.searchIcon} />
                    </IconButton>
                  </InputAdornment>
                }
                onMouseEnter={handleSearchHoverOpen}
                onMouseLeave={handleSearchHoverClose}
              />
            </div>

            <Hidden smDown>
              <List className={classes.navigationContainer}>
                {navlink.map((page, i) => (
                  <div key={i}>
                    <ListItem
                      button
                      component='a'
                      href={page.link}
                      className={classes.listItem}
                    >
                      <Typography
                        variant='subtitle2'
                        color='textPrimary'
                        className={classNames(
                          classes.listItemText,
                          "menu-item",
                        )}
                      >
                        <Box>{page.title}</Box>
                      </Typography>
                    </ListItem>
                  </div>
                ))}
              </List>
            </Hidden>

            <Hidden mdUp>
              <div>
                <IconButton
                  className={classNames(
                    classes.iconButton,
                    classes.headerMenuButton,
                  )}
                  onClick={e => setMinimalMenu(e.currentTarget)}
                  aria-haspopup='true'
                  aria-label='Menu'
                  aria-controls='minimal-menu'
                >
                  <MenuIcon />
                </IconButton>
                <div className={classes.profileMenuUser}>
                  <Menu
                    id='minimal-menu'
                    open={Boolean(minimalMenu)}
                    anchorEl={minimalMenu}
                    onClose={() => setMinimalMenu(null)}
                    className={classes.headerMenu}
                    classes={{ paper: classes.profileMenu }}
                    disableAutoFocusItem
                  >
                    {navlink.map(item => (
                      <MenuItem
                        key={item.id}
                        id={item.id}
                        className={classNames(
                          classes.profileMenuItem,
                          classes.headerMenuItem,
                        )}
                        onClick={() => {
                          if (item.link.match(/https?:\/\//)) {
                            window.location.href = item.link;
                          } else {
                            history.push(item.link);
                          }
                          setMinimalMenu(null);
                        }}
                      >
                        {item.title}
                      </MenuItem>
                    ))}
                  </Menu>
                </div>
              </div>
            </Hidden>

            <List
              className={classNames(classes.navigationContainer, {
                [classes.hide]: isAuthenticated,
              })}
            >
              <ListItem>
                <StyledButton
                  className={classes.signupButton}
                  href={`${loginUrl}`}
                >
                  {isSm ? "登入" : "註冊/登入"}
                </StyledButton>
              </ListItem>
            </List>

            <IconButton
              aria-haspopup='true'
              color='inherit'
              className={classNames(
                classes.headerMenuButton,
                classes.listItem,
                {
                  [classes.hide]: !isAuthenticated,
                },
              )}
              aria-controls='profile-menu'
              onClick={e => setProfileMenu(e.currentTarget)}
            >
              <AccountIcon classes={{ root: classes.headerIcon }} />
              <Typography variant='subtitle2' className={classes.listItemText}>
                {userName}
              </Typography>
            </IconButton>
            <div className={classes.profileMenuUser}>
              <Menu
                id='profile-menu'
                open={Boolean(profileMenu)}
                anchorEl={profileMenu}
                onClose={() => setProfileMenu(null)}
                className={classes.headerMenu}
                classes={{ paper: classes.profileMenu }}
                disableAutoFocusItem
              >
                <MenuItem
                  className={classNames(
                    classes.profileMenuItem,
                    classes.headerMenuItem,
                  )}
                  onClick={() => {
                    history.push("/app/member");
                    setProfileMenu(null);
                  }}
                >
                  <Grid
                    container
                    direction='column'
                    justify='center'
                    alignItems='flex-start'
                  >
                    <Grid item xs={12}>
                      <Box className={classes.profileSubTitle}> 帳號資訊 </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Grid item xs={12}>
                        <Box className={classes.profileSubBody}>
                          尚可觀看人數:{" "}
                          {!isPending && device_limit - device_in_use}
                        </Box>
                        <Box className={classes.profileSubBody}>
                          目前觀看人數: {device_in_use}
                        </Box>
                      </Grid>
                      <Box className={classes.profileSubBody}>
                        截止日:
                        {get(userInfo, "subscribe_to", "").substr(0, 10)}
                      </Box>
                    </Grid>
                  </Grid>
                </MenuItem>
                {get(userInfo, "user_type") === 0 && (
                  <MenuItem
                    className={classNames(
                      classes.profileMenuItem,
                      classes.headerMenuItem,
                    )}
                    onClick={() => {
                      history.push("/app/password-recovery");
                      setProfileMenu(null);
                    }}
                  >
                    密碼修改
                  </MenuItem>
                )}

                <MenuItem
                  className={classNames(
                    classes.profileMenuItem,
                    classes.headerMenuItem,
                  )}
                  onClick={() => {
                    history.push("/app/watched");
                    setProfileMenu(null);
                  }}
                >
                  觀看紀錄
                </MenuItem>
                <MenuItem
                  className={classNames(
                    classes.profileMenuItem,
                    classes.headerMenuItem,
                  )}
                  onClick={() => {
                    window.open(intro_url, "_blank");
                    setProfileMenu(null);
                  }}
                >
                  關於我們
                </MenuItem>
                <Divider variant='middle' />
                <MenuItem
                  className={classNames(
                    classes.profileMenuItem,
                    classes.headerMenuItem,
                  )}
                  onClick={() =>
                    signOut(userDispatch, props.history, pushInstruction)
                  }
                >
                  <Box>登出</Box>
                </MenuItem>
              </Menu>
            </div>
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
}
